export default __webpack_public_path__ + "static/media/11-2.e2226aea.mp3";